(() => {
  document.querySelectorAll('[data-ai-component="mosaic-gallery"], [data-ai-component="holographic-grid"], [data-ai-component="gaming-pricing"], [data-ai-component="challenge-dashboard"]').forEach((root) => {
    root.style.display = 'block';
  });

  document.querySelectorAll('[data-ai-component="gaming-pricing"]').forEach((root) => {
    root.querySelectorAll('[data-ai-gaming-card]').forEach((card) => {
      card.addEventListener('mouseenter', () => {
        card.style.zIndex = '10';
      });
      card.addEventListener('mouseleave', () => {
        card.style.zIndex = '1';
      });
    });
  });

  document.querySelectorAll('[data-ai-component="challenge-dashboard"]').forEach((root) => {
    const boxes = Array.from(root.querySelectorAll('[data-ai-challenge-box]'));
    const visibleClass = root.dataset.visibleClass || '';

    root.querySelectorAll('[data-ai-challenge-button]').forEach((button) => {
      button.setAttribute('role', 'button');
    });

    boxes.forEach((box, index) => {
      box.style.animationDelay = `${index * 0.08}s`;
    });

    if (!visibleClass) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(visibleClass);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      boxes.forEach((box) => observer.observe(box));
    } else {
      boxes.forEach((box) => box.classList.add(visibleClass));
    }
  });
})();
